import { useState, useEffect } from "react";
import { useModal } from "../../../../utils/ModalContext";
import "./step.css";
import { serializeError } from "eth-rpc-errors";
import FormCheckout from "../../../../common/form/FormCheckout";
import LoginModal from "../../../../common/modal/loginModal/LoginModal";
import { useSelector, useDispatch } from "react-redux";
import {
  // couponCheck,
  setPriceRTK,
} from "../../../../utils/redux/slices/checkoutSlice";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../ui/card";
import { Popover, PopoverContent, PopoverTrigger } from "../../../ui/popover";
// import { Input } from "../../../ui/input";
// import { Label } from "../../../ui/label";
// import { Button } from "../../../../components/ui/button";
import PopupLoader from "../../popupLoader";
import PopupError from "../../popupError";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs";
import { resetUser } from "../../../../utils/redux/slices/userSlice";
import useCouponHook from "../../../../hook/useCouponHook";
import { Info } from "lucide-react";
import { PRICE_LAND } from "../../../../utils/constants";

const StepPayment = (props) => {
  const {
    loginModalVisibility,
    openLoginModalHandle,
    popupHandle,
    isPopup,
    isPopupError,
    popupErrorHandle,
  } = useModal();
  const { coupon,price, setPrice, newPrice } =
    useCouponHook();
  const { setNextButton, selectLand, setPayment } = props;
  // const [tokenLocal, setTokenLocal] = useState(null);
  const [error, setError] = useState("null");
  const [activeForm, setActiveForm] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    setPrice(selectLand?.length * PRICE_LAND);
    dispatch(setPriceRTK(selectLand?.length * PRICE_LAND));
    setNextButton(false);
  }, []);

  const token = useSelector((state) => state?.user?.data?.data?._token);
  const user = useSelector((state) => state?.user?.user);
  const priceRTK = useSelector((state) => state?.checkout?.price);
  const newPriceRTK = useSelector((state) => state?.checkout?.newPrice);
  // const couponValidate = useSelector((state) => state?.checkout?.coupon);

  const logoutModalHandle = () => {
    localStorage.removeItem("token");
    // setTokenLocal(null);
    dispatch(resetUser());
  };

  const errorNotification = (errorMessage) => {
    const serializedError = serializeError(errorMessage);
    const error = serializedError.data.originalError.reason;
    setError(error.replace("execution reverted: ", ""));

    popupErrorHandle();
  };

  // useEffect(() => {
  //   setNextButton(false);
  //   const actualTokenLocal = localStorage.getItem("token");
  //   if (actualTokenLocal) {
  //     setTokenLocal(actualTokenLocal);
  //   } else if (token) {
  //     setTokenLocal(token);
  //   } else {
  //     setTokenLocal("");
  //   }
  // }, [token]);

  // const handleCouponChange = (event) => {
  //   console.log("coupon", event.target.value);
  //   setCoupon(event.target.value);
  // };

  // const handleApplyCoupon = () => {
  //   const data = {
  //     data: {
  //       coupon: coupon,
  //     },
  //   };

  //   dispatch(couponCheck(data));
  // };

  return (
    <>
      <div>
        {loginModalVisibility && <LoginModal />}
        <div className="mb-4">
          {user && user.data ? (
            <>
              <div
                className="text-general font-general cursor-pointer"
                onClick={() => logoutModalHandle()}
              >
                Logout
              </div>
            </>
          ) : (
            <>
              <div className="text-white font-general">
                Already have an account?
              </div>
              <span
                className="text-general font-general cursor-pointer"
                onClick={() => openLoginModalHandle()}
              >
                Login
              </span>
            </>
          )}
        </div>

        <Tabs
          defaultValue="creditcard"
          className="md:w-[600px] sm:w-[350px] mx-auto"
        >
          {activeForm && (
            <TabsList className="grid w-full gap-x-8 grid-cols-3">
              <TabsTrigger className="font-general" value="creditcard">
                CREDIT CARD
              </TabsTrigger>
              <TabsTrigger className="font-general" value="usdc">
                USDC
              </TabsTrigger>
              <TabsTrigger className="font-general" value="usdt">
                USDT
              </TabsTrigger>
            </TabsList>
          )}

          <TabsContent value="creditcard">
            <Card>
              <CardHeader>
                <CardTitle>CREDIT CARD</CardTitle>
                <CardDescription>
                  <div className="flex justify-center gap-2 mb-2 items-center">
                    <div>
                      You are buying{" "}
                      <span className="text-bold font-general text-lg text-black">
                        {selectLand?.length}
                      </span>{" "}
                      land.
                    </div>
                    <div>
                      <Popover>
                        <PopoverTrigger>
                          <Info className="w-5 h-5" />
                        </PopoverTrigger>
                        <PopoverContent>
                          <div className="flex justify-between font-general">
                            <div>Lands</div>
                            <div>Coordinates</div>
                          </div>
                          {selectLand && selectLand?.length > 0
                            ? selectLand.map((land, index) => (
                                <div key={index}>
                                  <div className="flex justify-between">
                                    <div className="font-medium">
                                      Land {index + 1}
                                    </div>
                                    <div className="font-medium">
                                      ({land.x}, {land.y})
                                    </div>
                                  </div>
                                </div>
                              ))
                            : null}
                        </PopoverContent>
                      </Popover>
                    </div>
                  </div>
                  {/* 
                  <div className="flex flex-col md:flex-row justify-around items-center">
                    {correctCoupon === true ? (
                      <>✅ Coupon successfully applied!</>
                    ) : correctCoupon === false && activeForm === true ? (
                      <div className="flex gap-2 items-end">
                        <div>
                          <Label className="label-Input-form">Coupon</Label>
                          <Input value={coupon} onChange={handleCouponChange} />
                        </div>
                        <div>
                          <Button
                            className="mx-auto font-general hover:bg-gray-600"
                            onClick={handleApplyCoupon}
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    ) : null}

                    <div>
                      <span className="text-bold font-general text-lg text-black">
                        TOTAL:
                      </span>{" "}
                      <span className="text-general font-general text-lg">
                        €{newPrice ? newPrice : price}
                      </span>{" "}
                    </div>
                  </div>
                  <div className="m-4">
                    {couponValidate && couponValidate.error && (
                      <div>❌ Invalid coupon!</div>
                    )}
                  </div> */}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="column">
                  <FormCheckout
                    setSuccessPayment={props.setSuccessPayment}
                    setPayment={setPayment}
                    setError={setError}
                    selectedPayment={"CREDITCARD"}
                    price={(newPriceRTK || newPriceRTK === 0) ? newPriceRTK : priceRTK}
                    selectedLand={selectLand}
                    coupon={coupon}
                    activeForm={activeForm}
                    setActiveForm={setActiveForm}
                  />
                </div>
                {/* <Stripe setSuccessPayment={props.setSuccessPayment} /> */}
              </CardContent>
              {/* <CardFooter>
              <Button className="mx-auto font-general">Pay Now</Button>
            </CardFooter> */}
            </Card>
          </TabsContent>
          <TabsContent value="usdc">
            <Card>
              <CardHeader>
                <CardTitle>USDC</CardTitle>
                <CardDescription>
                  You are buying{" "}
                  <span className="text-bold font-general text-lg text-black">
                    {selectLand?.length}
                  </span>{" "}
                  land.
                  <br />
                  <br />
                  {/* <span className="text-bold font-general text-lg text-black">
                    TOTAL:
                  </span>{" "}
                  <span className="text-general font-general text-lg">
                    €{price}
                  </span>{" "} */}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="column">
                  <FormCheckout
                    setSuccessPayment={props.setSuccessPayment}
                    setPayment={setPayment}
                    setError={setError}
                    selectedPayment={2}
                    price={price}
                    selectedLand={selectLand}
                    coupon={coupon}
                    activeForm={activeForm}
                    setActiveForm={setActiveForm}
                  />
                </div>
              </CardContent>
              {/* <CardFooter>
              <Button
                onClick={() => handleMint(2)}
                className="mx-auto font-general"
              >
                Pay Now
              </Button>
            </CardFooter> */}
            </Card>
          </TabsContent>
          <TabsContent value="usdt">
            <Card>
              <CardHeader>
                <CardTitle>USDT</CardTitle>
                <CardDescription>
                  You are buying{" "}
                  <span className="text-bold font-general text-lg text-black">
                    {selectLand?.length}
                  </span>{" "}
                  land.
                  <br />
                  <br />
                  {/* <span className="text-bold font-general text-lg text-black">
                    TOTAL:
                  </span>{" "}
                  <span className="text-general font-general text-lg">
                    €{price}
                  </span>{" "} */}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-2">
                <div className="column">
                  <FormCheckout
                    setSuccessPayment={props.setSuccessPayment}
                    setPayment={setPayment}
                    setError={setError}
                    selectedPayment={3}
                    price={price}
                    selectedLand={selectLand}
                    coupon={coupon}
                    activeForm={activeForm}
                    setActiveForm={setActiveForm}
                  />
                </div>
              </CardContent>
              {/* <CardFooter>
              <Button
                onClick={() => handleMint(3)}
                className="mx-auto font-general"
              >
                Pay Now
              </Button>
            </CardFooter> */}
            </Card>
          </TabsContent>
        </Tabs>
      </div>

      {isPopup && (
        <div className="popup__container">
          <PopupLoader popupHandle={popupHandle} />
        </div>
      )}
      {isPopupError && (
        <div className="popup__container">
          <PopupError popupHandle={popupErrorHandle} error={error} />
        </div>
      )}
    </>
  );
};

export default StepPayment;
